import { useTranslation } from "react-i18next";
import "../../css/Swap/Swap.css";
import { useContext, useEffect, useRef, useState } from "react";
import { WalletContext } from "../Wallet/WalletProvider";
import { ConvertValueRequest, SwapRequest } from "./SwapRequest";
import TokenSelection from "./TokenSelection";
import { setTokenSourceMapRange } from "typescript";
import { useNavigate } from "react-router-dom";
import { ConvertDollarToToman } from "../Wallet/Convert/ConvertDollarToToman";

function Swap({ theme }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [sendType, setSendType] = useState("T");
  const [sendTypeStatus, setSendTypeStatus] = useState(false);
  const [receiveType, setReceiveType] = useState("USDT");
  const [receiveTypeStatus, setReceiveTypeStatus] = useState(false);

  const [sendInputValue, setSendInputValue] = useState(0);
  const [sendInputRawValue, setSendInputRawValue] = useState(0);
  const [receiveInputValue, setReceiveInputValue] = useState(0);
  const [receiveInputRawValue, setReceiveInputRawValue] = useState(0);

  const sendInputRef = useRef(null);
  const receiveInputRef = useRef(null);

  const { tokensInfo, tomanAPI, trxAPIData } = useContext(WalletContext);

  const convertValueRequestTimeoutRef = useRef(null);

  const [generalStatus, setGeneralStatus] = useState(false);

  const [receiveTokenSelectionStatus, setReceiveTokenSelectionStatus] =
    useState(false);
  const [sendTokenSelectionStatus, setSendTokenSelectionStatus] =
    useState(false);

  useEffect(() => {
    if (sendInputRef.current) {
      sendInputRef.current.focus();
    }

    console.log(tokensInfo);
  }, [tokensInfo]);

  const [swapRequestStatus, setSwapRequestStatus] = useState(false);

  const convertOperation = (rawValue) => {
    if (sendTypeStatus) {
      if (sendType === "T" && receiveType === "USDT") {
        setReceiveInputValue(
          Number(rawValue) /
            tomanAPI["result"]["symbols"]["USDTTMN"]["stats"]["lastPrice"],
        );
        receiveInputRef.current.value =
          Number(rawValue) /
          tomanAPI["result"]["symbols"]["USDTTMN"]["stats"]["lastPrice"];
      } else if (sendType == "T" && receiveType == "TRX") {
        setReceiveInputValue(
          Number(rawValue) /
            tomanAPI["result"]["symbols"]["TRXTMN"]["stats"]["lastPrice"],
        );
        receiveInputRef.current.value =
          Number(rawValue) /
          tomanAPI["result"]["symbols"]["TRXTMN"]["stats"]["lastPrice"];
      } else if (sendType == "USDT" && receiveType == "T") {
        setReceiveInputValue(
          Number(rawValue) *
            tomanAPI["result"]["symbols"]["USDTTMN"]["stats"]["lastPrice"],
        );
        receiveInputRef.current.value =
          Number(rawValue) *
          tomanAPI["result"]["symbols"]["USDTTMN"]["stats"]["lastPrice"];
      } else if (sendType == "USDT" && receiveType == "TRX") {
        setReceiveInputValue(Number(rawValue) / Number(trxAPIData.c));
        receiveInputRef.current.value = Number(rawValue) / Number(trxAPIData.c);
      } else if (sendType == "TRX" && receiveType == "T") {
        setReceiveInputValue(
          Number(rawValue) *
            tomanAPI["result"]["symbols"]["TRXTMN"]["stats"]["lastPrice"],
        );
        receiveInputRef.current.value =
          Number(rawValue) *
          tomanAPI["result"]["symbols"]["TRXTMN"]["stats"]["lastPrice"];
      } else if (sendType == "TRX" && receiveType == "USDT") {
        setReceiveInputValue(Number(rawValue) * Number(trxAPIData.c));
        receiveInputRef.current.value = Number(rawValue) * Number(trxAPIData.c);
      }
    } else if (receiveTypeStatus) {



      if (sendType === "T" && receiveType === "USDT") {
        setSendInputValue(
          Number(rawValue) *
            tomanAPI["result"]["symbols"]["USDTTMN"]["stats"]["lastPrice"],
        );
        sendInputRef.current.value =
          Number(rawValue) *
          tomanAPI["result"]["symbols"]["USDTTMN"]["stats"]["lastPrice"];
      } else if (sendType == "T" && receiveType == "TRX") {
        setSendInputValue(
          Number(rawValue) *
            tomanAPI["result"]["symbols"]["TRXTMN"]["stats"]["lastPrice"],
        );
        sendInputRef.current.value =
          Number(rawValue) *
          tomanAPI["result"]["symbols"]["TRXTMN"]["stats"]["lastPrice"];
      } else if (sendType == "USDT" && receiveType == "T") {
        setSendInputValue(
          Number(rawValue) /
            tomanAPI["result"]["symbols"]["USDTTMN"]["stats"]["lastPrice"],
        );
        sendInputRef.current.value =
          Number(rawValue) /
          tomanAPI["result"]["symbols"]["USDTTMN"]["stats"]["lastPrice"];
      } else if (sendType == "USDT" && receiveType == "TRX") {
        setSendInputValue(Number(rawValue) * Number(trxAPIData.c));
        sendInputRef.current.value = Number(rawValue) * Number(trxAPIData.c);
      } else if (sendType == "TRX" && receiveType == "T") {
        setSendInputValue(
          Number(rawValue) *
            tomanAPI["result"]["symbols"]["TRXTMN"]["stats"]["lastPrice"],
        );
        sendInputRef.current.value =
          Number(rawValue) *
          tomanAPI["result"]["symbols"]["TRXTMN"]["stats"]["lastPrice"];
      } else if (sendType == "TRX" && receiveType == "USDT") {
        setSendInputValue(Number(rawValue) * Number(trxAPIData.c));
        sendInputRef.current.value = Number(rawValue) * Number(trxAPIData.c);
      }
    }
  };

  useEffect(() => {
    if (sendTypeStatus) {
      convertOperation(sendInputRawValue)
    } else if (receiveTypeStatus) {
      convertOperation(receiveInputRawValue)
    }
    
  }, [sendTypeStatus, receiveTypeStatus, sendInputRawValue, receiveInputRawValue])

  useEffect(() => {
    if (sendType == "T") {
      if (
        Number(sendInputValue) > 0 &&
        Number(receiveInputValue) > 0 &&
        Number(sendInputValue) <
          Number(tokensInfo[0]?.tokens.find((t) => t.symbol === "T")?.balance)
      ) {
        setGeneralStatus(true);
      } else {
        setGeneralStatus(false);
      }
    } else if (sendType == "USDT") {
      if (
        Number(sendInputValue) > 0 &&
        Number(receiveInputValue) > 0 &&
        Number(sendInputValue) <
          Number(
            tokensInfo[0]?.tokens.find((t) => t.symbol === "USDT")?.balance,
          )
      ) {
        setGeneralStatus(true);
      } else {
        setGeneralStatus(false);
      }
    } else if (sendType == "TRX") {
      if (
        parseFloat(sendInputValue) > 0 &&
        parseFloat(receiveInputValue) > 0 &&
        parseFloat(sendInputValue) <
          Number(tokensInfo[0]?.tokens.find((t) => t.symbol === "TRX")?.balance)
      ) {
        setGeneralStatus(true);
      } else {
        setGeneralStatus(false);
      }
    }
  }, [sendInputValue, receiveInputValue, sendType, tomanAPI]);

  useEffect(() => {
    if (sendType == "T" && receiveType === "T") {
      setReceiveType("USDT");
    } else if (sendType == "TRX" && receiveType == "TRX") {
      setReceiveType("T");
    } else if (sendType == "USDT" && receiveType == "USDT") {
      setReceiveType("T");
    }
    setSendInputValue("");
    setReceiveInputValue("");
    sendInputRef.current.value = "";
    receiveInputRef.current.value = "";
    sendInputRef.current.focus();
  }, [sendType, receiveType]);

  return (
    <div className="swapMainDiv">
      <div className={`swapHeaderDiv ${theme}`}>
        <div>{t("Swap")}</div>
        <img src="/images/by1ex_512.png"></img>
      </div>

      <div className="swapContentDiv">
        <div className={`swapInfoDiv ${theme}`}>
          <div className="sendTitlesDiv">
            <div className="sendTitleDiv">{t("Send")}</div>
            {sendType == "T"
              ? sendInputValue &&
                Number(sendInputValue) >
                  Number(
                    tokensInfo[0]?.tokens.find((t) => t.symbol === "T")
                      ?.balance,
                  ) && (
                  <div className="insufficientBalanceErrorDiv">
                    {t("Insufficient balance")}
                  </div>
                )
              : sendType == "USDT"
                ? sendInputValue &&
                  Number(sendInputValue) >
                    Number(
                      tokensInfo[0]?.tokens.find((t) => t.symbol === "USDT")
                        ?.balance,
                    ) && (
                    <div className="insufficientBalanceErrorDiv">
                      {t("Insufficient balance")}
                    </div>
                  )
                : sendType == "TRX"
                  ? sendInputValue &&
                    Number(sendInputValue) >
                      Number(
                        tokensInfo[0]?.tokens.find((t) => t.symbol === "TRX")
                          ?.balance,
                      ) && (
                      <div className="insufficientBalanceErrorDiv">
                        {t("Insufficient balance")}
                      </div>
                    )
                  : null}
          </div>
          <div className="swapInfoDiv2">
            <input
              className="swapInput"
              ref={sendInputRef}
              type="text"
              inputMode="decimal"
              pattern="[0-9.]*"
              onChange={(e) => {
                if (e.target.value.length > 0) {
                  const rawValue = e.target.value.replace(/,/g, "");
                  const value = rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  e.target.value = value;

                  setSendInputValue(rawValue);
                  const InputType = "send";

                  setSendInputRawValue(rawValue);

                  
                  setSendTypeStatus(true);
                  setReceiveTypeStatus(false);
                }
              }}
            ></input>

            {sendType == "T" ? (
              <div
                className="swapTypeDiv"
                onClick={() => setSendTokenSelectionStatus(true)}
              >
                <img src="/icons/toman.png"></img>
                <div>{t("T")}</div>
              </div>
            ) : sendType == "USDT" ? (
              <div
                className="swapTypeDiv"
                onClick={() => setSendTokenSelectionStatus(true)}
              >
                <img src="/icons/usdt.png"></img>
                <div>{t("USDT")}</div>
              </div>
            ) : sendType == "TRX" ? (
              <div
                className="swapTypeDiv"
                onClick={() => setSendTokenSelectionStatus(true)}
              >
                <img src="/icons/trx.png"></img>
                <div>{t("Tron TRX")}</div>
              </div>
            ) : (
              <></>
            )}

            {sendTokenSelectionStatus && (
              <TokenSelection
                theme={theme}
                setTokenSelectionStatus={setSendTokenSelectionStatus}
                currentToken={sendType}
                setToken={setSendType}
              ></TokenSelection>
            )}
          </div>
        </div> 

        <div className={`swapInfoDiv ${theme}`}>
          <div>{t("Receive")}</div>
          <div className="swapInfoDiv2">
            <input
              className="swapInput"
              ref={receiveInputRef}
              type="text"
              inputMode="decimal"
              pattern="[0-9.]*"
              onChange={(e) => {
                if (e.target.value.length > 0) {
                  const rawValue = e.target.value.replace(/,/g, "");
                  const value = rawValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  e.target.value = value;

                  setReceiveInputValue(rawValue);

                  const InputType = "receive";

                  setReceiveInputRawValue(rawValue);
                 
                  setSendTypeStatus(false);
                  setReceiveTypeStatus(true);
                }
              }}
            ></input>

            {receiveType == "USDT" ? (
              <div
                className="swapTypeDiv"
                onClick={() => {
                  setReceiveTokenSelectionStatus(true);
                }}
              >
                <img src="/icons/usdt.png"></img>
                <div>{t("USDT")}</div>
              </div>
            ) : receiveType == "TRX" ? (
              <div
                className="swapTypeDiv"
                onClick={() => {
                  setReceiveTokenSelectionStatus(true);
                }}
              >
                <img src="/icons/trx.png"></img>
                <div>{t("Tron TRX")}</div>
              </div>
            ) : receiveType == "T" ? (
              <div
                className="swapTypeDiv"
                onClick={() => {
                  setReceiveTokenSelectionStatus(true);
                }}
              >
                <img src="/icons/toman.png"></img>
                <div>{t("Toman")}</div>
              </div>
            ) : (
              <></>
            )}

            {receiveTokenSelectionStatus && (
              <TokenSelection
                theme={theme}
                setTokenSelectionStatus={setReceiveTokenSelectionStatus}
                currentToken={receiveType}
                setToken={setReceiveType}
              ></TokenSelection>
            )}
          </div>
        </div>

        <button
          className={`submit_button ${generalStatus && "active"} `}
          onClick={() => {
            if (generalStatus) {
              setSwapRequestStatus(true);
              SwapRequest(
                Number(sendInputValue),
                Number(receiveInputValue),
                sendType,
                receiveType,
                navigate,
                setSwapRequestStatus,
              );
            }
          }}
        >
          {!swapRequestStatus ? (
            t("Continue (fee 0)")
          ) : (
            <img
              src="/icons/loading.png"
              className={`icon rotate ${theme}`}
            ></img>
          )}
        </button>
      </div>
    </div>
  );
}

export default Swap;
